import doubleSameItem from './partials/double-same-item'

const doubleSameBase = {
    DoubleSame: {
        baseStyle: ({isMobileRow, backgroundColor, isBeforeRightMobile, adaptiveHeight}) => ({
            grid: {
                templateColumns: 'repeat(12, 1fr)',
                gap: 'spacing.0',
                ...(adaptiveHeight && {
                    h: '100%',
                    alignItems: 'center',

                    w: '100%',
                    // display: 'flex',
                }),
            },
            gridItemLeft: {
                colSpan: {base: isMobileRow ? 6 : 12, md: 6},

                // flex: '1 1',
                // h: '100%',
            },
            gridItemRight: {
                colSpan: {base: isMobileRow ? 6 : 12, md: 6},
                order: {base: isBeforeRightMobile ? '-1' : 'unset', md: 'unset'},

                // flex: '1 1',
                // h: '100%',
            },
            wrapper: {
                bg: backgroundColor ? backgroundColor : 'color.background.transparent',
                w: '100%',
                gridColumn: '1 / -1', // Starts from the first column end ends at the last column
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                ...(adaptiveHeight && {
                    h: {base: '100%', md: 'auto'},
                }),
            },
            itemWrapper: {
                height: '100%',
            },
        }),
    },
}

const doubleSame = {
    ...doubleSameBase,
    ...doubleSameItem,
}

export default doubleSame
